<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="materialSelectItems"
            v-model="item.material"
            :items="filteredMaterialSelectItems"
            :error-messages="materialErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.printingsurface.material')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.version"
            :error-messages="versionErrors"
            :label="$t('profile.printingsurface.version')"
            required
            @input="$v.item.version.$touch()"
            @blur="$v.item.version.$touch()"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="sizeSelectItems"
            v-model="item.size"
            :items="sizeSelectItems"
            :error-messages="sizeErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.printingsurface.size')"
            item-text="size"
            item-value="@id"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="thicknessSelectItems"
            v-model="item.thickness"
            :items="thicknessSelectItems"
            :error-messages="thicknessErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.printingsurface.thicknessname')"
            item-text="size"
            item-value="@id"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <strong class="ml-4" >{{ $t('global.archive') }}:</strong>
          <v-switch
                v-model="item.archive"
                :error-messages="archiveErrors"
              ></v-switch>
        </v-col>
      </v-row>

    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';

export default {
  name: 'PrintingSurfaceForm',
  mixins: [validationMixin],
  components: {
    Loading
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
      this.materialGetSelectItems();
      this.sizeGetSelectItems();
      this.thicknessGetSelectItems();
  },
  data() {
    return {
        material: null,
        size: null,
        thickness: null,
        archive: null,
    };
  },
  computed: {
      isLoading() {
        return (this.isLoading_printingsurfacematerial ||
           this.isLoading_printingsurfacesize ||
           this.isLoading_printingsurfacethickness
         );
      },
      ...mapFields('printingsurfacematerial', {
        materialSelectItems: 'selectItems',
        isLoading_printingsurfacematerial : 'isLoading'
      }),
      ...mapFields('printingsurfacesize', {
        sizeSelectItems: 'selectItems',
        isLoading_printingsurfacesize : 'isLoading'
      }),
      ...mapFields('printingsurfacethickness', {
        thicknessSelectItems: 'selectItems',
        isLoading_printingsurfacethickness : 'isLoading'
      }),

      filteredMaterialSelectItems() {
        return this.materialSelectItems.filter(material => !material.archive);
      },

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    materialErrors() {
      const errors = [];

      if (!this.$v.item.material.$dirty) return errors;

      has(this.violations, 'material') && errors.push(this.violations.material);


      return errors;
    },
    sizeErrors() {
      const errors = [];

      if (!this.$v.item.size.$dirty) return errors;

      has(this.violations, 'size') && errors.push(this.violations.size);


      return errors;
    },
    thicknessErrors() {
      const errors = [];

      if (!this.$v.item.thickness.$dirty) return errors;

      has(this.violations, 'thickness') && errors.push(this.violations.thickness);


      return errors;
    },
    versionErrors() {
      const errors = [];

      if (!this.$v.item.version.$dirty) return errors;

      has(this.violations, 'version') && errors.push(this.violations.version);

      !this.$v.item.version.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    archiveErrors() {
      const errors = [];
      if (!this.$v.item.archive.$dirty) return errors;
      has(this.violations, 'archive') && errors.push(this.violations.archive);
      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  methods: {
      ...mapActions({
        materialGetSelectItems: 'printingsurfacematerial/fetchSelectItems'
      }),
      ...mapActions({
        sizeGetSelectItems: 'printingsurfacesize/fetchSelectItems'
      }),
      ...mapActions({
        thicknessGetSelectItems: 'printingsurfacethickness/fetchSelectItems'
      }),
  },
  validations: {
    item: {
      material: {
      },
      size: {
      },
      thickness: {
      },
      version: {
        required,
      },
      archive: {

      },
    }
  }
};
</script>
